import React from 'react'
import { Controller } from 'react-hook-form'
import { TextField } from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import ja from 'date-fns/locale/ja'

export default function FormDatePicker(props) {
  return (
      <Controller
        control={props.control}
        name={props.name}
        hintText={props.hintText}
        defaultValue={props.defaultValue}

        render={({ field }) => (
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={ja}>
            <DateTimePicker
              {...field}
              inputFormat='yyyy-MM-dd'
              mask='____-__-__'
              sx={{backgroundColor:'white', margin:'16px 3px'}}
              minutesStep={30}

              renderInput={(params,) =>
                <TextField {...params} 
                label={props.hintText}
                size='small' 
                error={!props.dateError ? false : true}
                onKeyUp={e => {
                  if (e.key === 'Enter') e.preventDefault();
                }}  
                helperText={props.dateError} />}
              onChange={(newValue) => {props.onChange(newValue)}}
            />
          </LocalizationProvider>
        )}
      />
  )
}